import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { Grid } from '@material-ui/core';
import Icons from '../Icons/Icons.component';
import Paper from '@material-ui/core/Paper';
import * as themeConstants from '../../Constants/Theme/Theme.constants';
import pageTipStyles from './PageTip.component.styles';

/**
 * PageTipComponent
 * @export
 * @class PageTipComponent
 * @extends {React.Component<PageTipComponentComposedProps, PageTipComponentState>}
 */
const PageTipComponent = ({ classes, content, alignItems = "flex-start" }) => {
  return (
    <Paper classes={{ root: classes.rootTip }} elevation={0}>
      <Grid container spacing={2} className={classes.flexWrapNowrap} alignItems={alignItems}>
        <Grid item>
          <Icons size="24" color={themeConstants.BORAL_GREEN} type="EMOJI_OBJECTS" className={classes.bannerTipsIcon} />
        </Grid>
        <Grid item className={classes.flexGrow1}>
          {content}
        </Grid>
      </Grid>
    </Paper>
  );
};

/** @type {React.ComponentClass<PageTipComponentProps>} */
const PageTip = compose(withStyles(themeCreateInjectableStyles(pageTipStyles), { withTheme: true }))(PageTipComponent);

export default PageTip;
